export const CSRF_TOKEN_NAME = 'csrftoken';
export const SESSION_ID_NAME = 'sessionid';
